// Text constants for ProjectsNullView component
const fallbackViewTexts = {
  cardTitle: 'Keep Every Job on Track - All in One Place',
  bodyText:
    'Manage materials, timelines, and team collaboration across every jobsite. '
    + 'Your project your way - from quote to delivery.',
  imageAlt: 'Projects placeholder image',
  buttonText: 'Create New Project',
  buttonTextDesktop: 'Create New',
  imageUrl:
    'https://dam.thdstatic.com/content/production/q7k5j90tEwVD1kPkixSQQQ/OkRd7qOTw_7UpErTtyrMew/'
    + 'Original%20file/WF-6260106-AccountQuotes-Hero.jpg',
  learnMoreText: 'Learn More',
  learnMoreLink: '/c/create-a-project',
};

export default fallbackViewTexts;
